var map = {
	"./area_management.png": 1744,
	"./area_management_big.jpg": 9231,
	"./carto.png": 6472,
	"./carto_big.jpg": 3496,
	"./collaborative_decision.png": 8516,
	"./collaborative_decision_big.jpg": 2925,
	"./dashboard.png": 1865,
	"./dashboard_big.jpg": 8603,
	"./ideas_request.png": 6705,
	"./ideas_request_big.jpg": 245,
	"./participative_budget.png": 923,
	"./participative_budget_big.jpg": 5239,
	"./secured_votes.png": 6052,
	"./secured_votes_big.jpg": 3365,
	"./study.png": 4654,
	"./study_big.jpg": 1447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7449;